import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';

export const evaluationKeys = {
  all: ['evaluations'] as const,
  lists: () => [...evaluationKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown> | undefined) =>
    [...evaluationKeys.all, 'list', { filters }] as const,
  details: () => [...evaluationKeys.all, 'detail'] as const,
  detail: (id: string) => [...evaluationKeys.details(), id] as const,
};

export function useEvaluations(filters?: { programId?: string; userId?: string }) {
  return useQuery({
    queryKey: evaluationKeys.list(filters),
    queryFn: () => apiClient.evaluations.list(filters),
  });
}

export function useEvaluation(id: string, userId?: string) {
  return useQuery({
    queryKey: evaluationKeys.detail(id),
    queryFn: () => apiClient.evaluations.get(id, userId),
    enabled: !!id,
  });
}

export function useStartAttempt() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ evaluationId, userId }: { evaluationId: string; userId: string }) =>
      apiClient.evaluations.startAttempt(evaluationId, userId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: evaluationKeys.all });
    },
  });
}

export function useSubmitAttempt() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      attemptId,
      answers,
    }: {
      attemptId: string;
      answers: { questionId: string; optionId: string }[];
    }) => apiClient.evaluations.submitAttempt(attemptId, answers),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: evaluationKeys.all });
    },
  });
}
